import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MenusModule } from '@progress/kendo-angular-menu';
import { CloudApplicationsAdminService } from '../cloud-applications-admin/services/cloud-applications-admin.service';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { AuthorizationService } from '../services/authorization/authorization.service';
import { TranslatePipe } from '@ngx-translate/core';
import {
  afCloudPortalAdminItems,
  afCustomerManagerItems,
  aclsItems,
  customerItems,
  carBodyPlannerItems,
  feasibilityAiItems,
  welcomeItems,
} from './toolbar-items';
import { AppsService } from '../services/apps/apps.service';

@Component({
  selector: 'af-toolbar',
  imports: [AsyncPipe, RouterLink, RouterLinkActive, MenusModule, TranslatePipe],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {

  public cloudPortalAdminItems = afCloudPortalAdminItems;
  public customerManagerItems = afCustomerManagerItems;
  public aclsItems = aclsItems;
  public hasCbp$!: Observable<boolean>;
  public hasFai$!: Observable<boolean>;
  public hasAcls$!: Observable<boolean>;
  public hasAnyApp$!: Observable<boolean>;

  public customerItems = customerItems;
  public carBodyPlannerItems = carBodyPlannerItems;
  public feasibilityAiItems = feasibilityAiItems;
  public welcomeItems = welcomeItems;

  constructor(
    private router: Router,
    protected authenticationService: AuthenticationService,
    protected authorizationService: AuthorizationService,
    protected cloudApplicationService: CloudApplicationsAdminService,
    protected appsService: AppsService
  ) {
    this.authenticationService.getCustomerId().subscribe()
   }

  ngOnInit() {
    this.cloudApplicationService.getCustomerPermissions();
    this.hasCbp$ = this.appsService.hasCbp();
    this.hasFai$ = this.appsService.hasFai();
    this.hasAcls$ = this.appsService.hasAclsAccess();
    this.hasAnyApp$ = combineLatest([
      this.appsService.hasAnyApp(),
      this.cloudApplicationService.hasAppStream$,
    ]).pipe(map(([hasAnyApp, hasAppStream]) => hasAnyApp || hasAppStream));
  }

  onSelect(item: any): void {
    this.router.navigate([item.item.path]);
  }
}
